import {Backdrop, Box, Fade, Modal} from '@mui/material';
import React from 'react';
import LoginSectionComponent from "./components/LoginSectionComponent";
import './loginSectionComponent.scss';
import RegistrationSectionComponent from "./components/RegistrationSectionComponent";

interface AuthModalProps {
    authStatus: boolean;
    isVisible: boolean;
    setIsVisible: (status: boolean) => void;
    handleAuthModal: (status: boolean) => void;
    authType: string;
    setAuthType: (type: string) => void;
}

const AuthModal = (props: AuthModalProps) => {
    const [open, setOpen] = React.useState(false);

    /* const hideCustomNavbarDisplay = () => {
        const navElements = document.querySelector('.authNavbar__container-nav-elements');
        const navLogo = document.querySelector('.authNavbar__container-logo');

        if (navElements && navLogo) {
            navLogo.setAttribute('style', 'z-index: 2');
        }
    } */

    const handleCloseModal = () => {
        props.setIsVisible(false);
        //hideCustomNavbarDisplay();
    }

    const style = {
        position: 'relative',
        /*left: '50%',
        */
        top: '0',
        /*transform: 'translate(-50%, 0)',*/
        border: 'none',
        outline: 'none',
        opacity: 1,
        //overflowY: 'auto',
        //scrollbarWidth: 'thin',
        //scrollbarColor: 'transparent transparent',
        //'-ms-overflow-style': 'none',
        //'scrollbar-color': 'transparent transparent',
        //'::-webkit-scrollbar': {
        //    width: '0.4em',
        //},
        //'::-webkit-scrollbar-thumb': {
        //    backgroundColor: 'transparent',
        //},
    };


    return (
        <div>
            <Modal
                className="authModal__container-modal"
                open={props.isVisible}
                onClose={handleCloseModal}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                {/*<Fade in={open}>*/}
                    {/*<Box sx={style}
                        className="authModal__container-box"
                    >*/}
	                <div className="authModal__container-box">
                      {
                        props.authType === 'login' && (
                          <LoginSectionComponent
                            handleCloseModal={() => props.setIsVisible(false)}
                            handleLogin={props.handleAuthModal}
                            redirectToRegistration={() => props.setAuthType('registration')}
                          />
                        )
                      }
                      {
                        props.authType === 'registration' && (
                          <RegistrationSectionComponent
                            handleCloseModal={() => props.setIsVisible(false)}
                            handleRegistration={props.handleAuthModal}
                            redirectToLogin={() => props.setAuthType('login')}
                          />
                        )
                      }
                  </div>

                    {/*</Box>*/}
                {/*</Fade>*/}
            </Modal>
        </div>
    );
};

export default AuthModal;